import { usePropertyExpectedTakeOutLoanAmount } from '../../../../../../queries/PropertyFields';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface ExpectedTakeOutLoanAmountProps {
    propertyGuid: string;
    required?: boolean;
    structureType: string | undefined;
    isReview?: boolean;
}

export const ExpectedTakeOutLoanAmount: React.FC<ExpectedTakeOutLoanAmountProps> = ({
    propertyGuid,
    required = false,
    structureType,
    isReview = false,
}) => {
    const [expectedTakeOutLoanAmount, set_expectedTakeOutLoanAmount] = usePropertyExpectedTakeOutLoanAmount(propertyGuid);

    const expectedTakeOutLoanAmountLabel = () => {
        if (
            structureType === 'Duplex' ||
            structureType === 'Triplex' ||
            structureType === 'Quadplex' ||
            structureType === '5+ Unit'
        ) {
            return 'Total Expected Take-Out Loan Amount';
        } else {
            return 'Expected Take-Out Loan Amount';
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={expectedTakeOutLoanAmountLabel()}
                    value={formatCurrencyOrUndefined(Number(expectedTakeOutLoanAmount))}
                />
            ) : (
                <MoneyBox
                    id='expectedTakeOutLoanAmount'
                    allowNegative={false}
                    value={expectedTakeOutLoanAmount}
                    onChange={(value) => {
                        set_expectedTakeOutLoanAmount(value);
                    }}
                    required={required}
                    label={expectedTakeOutLoanAmountLabel()}
                    displayChange={false}
                />
            )}
        </>
    );
};
